const defaultI18nConfig = {
  fallbackLng: {
    ca: ["ca-ES", "ca", "en"],
    fr: ["fr-FR", "en"],
    "ja-JP": ["ja", "en"],
    "es-*": ["es", "en"],
    "en-GB-*": ["en-GB", "en"],
    default: ["en"]
  },
  detection: {
    // An empty array is passed to prevent default localStorage caching
    caches: [],
    lookupQuerystring: "lang_code",
    order: ["htmlTag", "querystring", "navigator"]
  },
  nonExplicitSupportedLngs: true,
  interpolation: { escapeValue: false },
  react: {
    useSuspense: true
  }
};
export {
  defaultI18nConfig
};
//# sourceMappingURL=config.js.map
